import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  COMPANY_NAME,
  QUESTION,
  QUESTION_SOURCE_TYPE,
  QUESTION_TYPE,
  SOURCE,
} from 'constants/formFields';
import { DEFAULT_OPTION } from 'constants/general';
import { questionCreateSchema } from 'utils/validators';

import type { TQuestionCreateSchema } from 'utils/validators';
import type ICreateQuestionForm from '../interfaces/ICreateQuestionForm';

const useCreateQuestionForm = ({ isPageLoading }: ICreateQuestionForm) => {
  const {
    control,
    handleSubmit,
    formState: { isDirty, isLoading },
    reset,
    setError,
    getValues,
    watch,
    setValue,
    resetField,
  } = useForm<TQuestionCreateSchema>({
    mode: 'onSubmit',
    resolver: yupResolver(questionCreateSchema),
    defaultValues: {
      [QUESTION]: '',
      [QUESTION_TYPE]: DEFAULT_OPTION,
      [QUESTION_SOURCE_TYPE]: DEFAULT_OPTION,
      [COMPANY_NAME]: '',
      [SOURCE]: '',
    },
  });

  useEffect(() => {
    if (!isPageLoading) {
      reset();
    }
  }, [reset, isPageLoading]);

  const fieldsName = Object.keys(getValues());

  return {
    control,
    handleSubmit,
    isDirty,
    reset,
    isLoading,
    setError,
    fieldsName,
    watch,
    setValue,
    resetField,
  };
};

export default useCreateQuestionForm;
